import React, { Component } from 'react'
import PropTypes from 'prop-types'

function withGuestEditModal(WrapperComponent) {
  class WithGuestEditModal extends Component {
    state = {
      isOpenEditModal: false,
      first_name: '',
      last_name: '',
      cohost: false,
      guestInfo: null,
      rsvpState: '',
      ticketCounts: []
    }

    closeModal = () => {
      this.setState({
        isOpenEditModal: false,
        first_name: '',
        last_name: '',
        cohost: false,
        guestInfo: null
      })
    }

    openModal = guest => {
      const { first_name, last_name, cohost } = guest
      const { event, ticketTypes, eventTicketCounts } = this.props

      const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)

      const { child_count_enabled, guest_count_enabled } = event

      const invitationTicketCounts = eventTicketCounts.invitations.find(invitation => invitation.id === guest.id)?.ticket_counts || []

      const ticketCounts = []

      const firstAdult = activeTicketTypes.find(ticketType => ticketType.label === 'adult')
      if (firstAdult) {
        let count = 1

        if (guest_count_enabled) {
          count = invitationTicketCounts.find(tc => tc.ticket_type_id === firstAdult.id)?.ticket_count || 1
        }
        ticketCounts.push({
          id: firstAdult.id,
          label: firstAdult.label,
          count
        })
      }

      if (child_count_enabled) {
        const firstChild = activeTicketTypes.find(ticketType => ticketType.label === 'child')
        if (firstChild) {
          const count = invitationTicketCounts.find(tc => tc.ticket_type_id === firstChild.id)?.ticket_count || 0
          ticketCounts.push({
            id: firstChild.id,
            label: firstChild.label,
            count
          })
        }
      }

      this.setState({
        isOpenEditModal: true,
        first_name,
        last_name,
        cohost,
        guestInfo: guest,
        rsvpState: guest.rsvp_state,
        ticketCounts: ticketCounts
      })
    }

    handleSave = (params) => {
      if (params) {
        this.props.onEditGuest(params)
        this.closeModal()
        return
      }
      const { first_name, last_name, cohost, rsvpState, ticketCounts } = this.state
      this.props.onEditGuest({ first_name, last_name, cohost, rsvpState, ticketCounts })

      this.closeModal()
    }

    handleInputChange = (name, value) => {
      if (name === 'ticketCounts') {
        this.setState(prevState => ({
          ticketCounts: prevState.ticketCounts.map(tc =>
            tc.id === value.id ? { ...tc, count: value.count } : tc
          )
        }))
      } else {
        this.setState({
          [name]: value
        })
      }
    }

    render() {
      return (
        <WrapperComponent
          {...this.state}
          isHost={this.props.isHost}
          event={this.props.event}
          isHostOrCohost={this.props.isHostOrCohost}
          onClose={this.closeModal}
          onSave={this.handleSave}
          onInputChange={this.handleInputChange}
          visibleContactInput={false}
          selectedGuest={this.props.selectedGuest}
          ticketTypes={this.props.ticketTypes}
          eventTicketCounts={this.props.eventTicketCounts}
          needPayTicket={this.props.needPayTicket}
        />
      )
    }
  }
  WithGuestEditModal.displayName = `WithGuestEditModal(${WrapperComponent.displayName})`
  WithGuestEditModal.propTypes = {
    isHost: PropTypes.bool,
    isHostOrCohost: PropTypes.bool,
    event: PropTypes.object,
    onEditGuest: PropTypes.func,
    selectedGuest: PropTypes.object,
    eventTicketCounts: PropTypes.object || null,
    ticketTypes: PropTypes.array,
    needPayTicket: PropTypes.bool
  }

  return WithGuestEditModal
}

export default withGuestEditModal
